import { render, staticRenderFns } from "./UnlinkAccount.vue?vue&type=template&id=1d90a072&lang=pug"
import script from "./UnlinkAccount.vue?vue&type=script&lang=js"
export * from "./UnlinkAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports